import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import StyledButtonNE from '../../../../../../shared/components/StyledButtonNE/StyledButtonNE';
import ToastNE from '../../../../../../shared/components/ToastNE/ToastNE';
import { DEFAULT_TOAST_DATA } from '../../../../../../shared/constants/toast';
import { IUserCompany } from '../../../../../../shared/interfaces/businessData';
import { IToast } from '../../../../../../shared/interfaces/toast';
import { TRANSLATIONS_SETTINGS } from '../../../../../../shared/translations/settings';
import BusinessDataChangeModal from '../../BusinessDataChangeModal/BusinessDataChangeModal';

interface ICollaboratorProps {
  company: IUserCompany;
}

const EditCompanyButton = ({ company }: ICollaboratorProps) => {
  const [changeCompanyModalOpen, setChangeCompanyModalOpen] = useState(false);
  const [changeCompanyToast, setChangeCompanyToast] = useState(false);
  const [toastData, setToastData] = useState<IToast>(DEFAULT_TOAST_DATA);

  const { t } = useTranslation();

  const handleClosedModal = (toastData?: IToast) => {
    if (toastData) {
      setToastData(toastData);
      setChangeCompanyToast(true);
    }
    setChangeCompanyModalOpen(false);
  };

  const handleCloseToast = () => {
    setChangeCompanyToast(false);
  };

  const openChangeBusinessDataModal = () => {
    setChangeCompanyModalOpen(true);
  };

  return (
    <>
      <StyledButtonNE buttonType="secondary" classes="table-send-email-button-ne" action={openChangeBusinessDataModal}>
        <div>{t(TRANSLATIONS_SETTINGS.businessData.edit)}</div>
      </StyledButtonNE>
      {changeCompanyModalOpen && (
        <BusinessDataChangeModal
          isModalOpen={changeCompanyModalOpen}
          handleCloseModal={handleClosedModal}
          id={company.id}
          name={company.name}
          isHolding={false}
        />
      )}
      <ToastNE
        title={t(toastData.title)}
        description={t(toastData.description)}
        icon={toastData.icon}
        open={changeCompanyToast}
        button={toastData.button}
        buttonText={t(toastData.buttonText)}
        buttonAction={handleCloseToast}
        handleClose={handleCloseToast}
      />
    </>
  );
};

export default EditCompanyButton;
